import { FileTypeActionTypes, FileTypeState, FileTypeTypes } from "@/main/store/fileType/fileTypeTypes";
import { Action, Reducer } from "redux";

export const INITIAL_STATE: FileTypeState = {
	fileType: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const fileTypeReducer: Reducer<FileTypeState> = (state: FileTypeState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as FileTypeActionTypes;
	switch (actionTypes.type) {
		case FileTypeTypes.GET_FILE_TYPE:
			return {
				...state,
				fileType: { ...state.fileType, isLoading: true },
			};
		case FileTypeTypes.SAVE_FILE_TYPE:
			return {
				...state,
				fileType: {
					...state.fileType,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case FileTypeTypes.RESET_REDUCER_FILE_TYPE:
			return {
				...state,
				fileType: INITIAL_STATE.fileType,
			};
		default:
			return state;
	}
};

export default fileTypeReducer;
